import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import Init from "./init";
import { store } from "./store";

import "./index.css";

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Init />
    </Provider>
  </React.StrictMode>,
);
